import styled from 'styled-components'

const Icon = styled.span`
  display: block;
  margin: 0 auto;
`

export default Icon
